import React from 'react';
import {
  EmailConfirmationFormValues,
  EmailConfirmationFormViolation,
} from 'types/emailConfirmationFormTypes';
import { createEmailConfirmationFormValues } from 'utils/emailConfirmationFormUtils';

export const useEmailConfirmationForm = () => {
  const [values, setValues] = React.useState<EmailConfirmationFormValues>(
    createEmailConfirmationFormValues
  );

  const [violations, setViolations] = React.useState<
    EmailConfirmationFormViolation[]
  >([]);

  const setCodeValue = React.useCallback((nextValue: string[]) => {
    setViolations([]);

    setValues((prev) => ({
      ...prev,
      code: nextValue,
    }));
  }, []);

  const setPasswordValue = React.useCallback((nextValue: string) => {
    setViolations([]);

    setValues((prev) => ({
      ...prev,
      password: nextValue,
    }));
  }, []);

  return {
    values,
    violations,
    setValues,
    setViolations,
    setCodeValue,
    setPasswordValue,
  };
};
